<template>
    <div class="collection_body">
      <van-nav-bar
        title="我的收藏"
      />
      <van-empty description="暂时没有收藏课程！" v-if="this.list==null || this.list.length==0"/>
      <div class="shoucang" v-for="item in list" @click="tiaozhuan(item)">
        <div class="tup"><img :src="item.covermap"></div>
        <div class="xiangqing">
          <div class="biaoti">{{item.titles}}</div>
          <div class="cishu">老师：{{item.teacher}}</div>
          <div class="shijian">课程简介：{{item.introduce}}</div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "collection",
        data(){
            return{
                list:[]
            }
        },
        created() {
            this.getdata()
        },
        methods:{
            tiaozhuan(item){
                this.$router.push({path: '/bank',query:{id:item.id}})
            },
            getdata() {
                this.myrequest({
                    url: '/client/getcollectionlist.action',
                    types: 'get',
                    data: {

                    },
                    succ: (res) => {
                        this.list=res.data
                    },
                    errs: (msg) => {

                    }
                })
            },
        }
    }
</script>

<style scoped lang="stylus">
.collection_body{
  width 100%;
  >>>.van-nav-bar{
    background #0AC1BA;
  }
  >>>.van-nav-bar__title{
    color #fff
  }
  .shoucang{
    width 95%;
    margin 10px auto;
    border-bottom 2px solid #efefef;
    height 110px;
    .tup{
      float left;
      img{
        width 150px;
        height 100px;
      }
    }
    .xiangqing{
      float left;
      margin-left 20px;
      margin-top 10px;
      .biaoti{
        color #333333;
        font-weight 500;
        font-size 16px;
        white-space: nowrap;/*一行显示*/
        overflow: hidden;/*超出部分隐藏*/
        text-overflow: ellipsis;/*用...代替超出部分*/
        width 180px
      }
      .cishu{
        color #ccc;
        margin-top 5px;
      }
      .shijian{
        color #ccc;
        margin-top 5px;
        -webkit-line-clamp: 2;//超出3行隐藏，并显示省略号
        overflow: hidden;
        display: -webkit-box;//将元素设为盒子伸缩模型显示
        -webkit-box-orient: vertical;//伸缩方向设为垂直方向
        width 180px
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wode/collection.vue